// Legacy letter endpoints are not exposed by the current backend schema.
// export const LETTER = '/letter/'
// export const LETTER_INCOMING = `${LETTER}incoming` as const
// export const LETTER_OUTGOING = `${LETTER}outgoing` as const
// export const LETTER_STATUS = `${LETTER}status` as const
// export const LETTER_PUBLIC_INFO = '/public/outgoing_letter'
export const EXTERNAL_LETTERS_LIST = '/external-letters/' as const
export const EXTERNAL_LETTERS_COMMENT_TEMPLATE = `${EXTERNAL_LETTERS_LIST}comment-template/` as const
export const EXTERNAL_LETTERS_REGISTER = `${EXTERNAL_LETTERS_LIST}register` as const
export const EXTERNAL_LETTERS_SEND_TO_INFORM = `${EXTERNAL_LETTERS_LIST}send-to-inform` as const
export const EXTERNAL_LETTERS_RESOLUTION = `${EXTERNAL_LETTERS_LIST}resolution` as const
export const EXTERNAL_LETTERS_CONFIRM_INFORMED = `${EXTERNAL_LETTERS_LIST}confirm-informed` as const
export const EXTERNAL_LETTERS_COMPLETE_EXECUTION = `${EXTERNAL_LETTERS_LIST}complete-execution` as const
export const EXTERNAL_LETTERS_REQUIRE_UPDATE = `${EXTERNAL_LETTERS_LIST}require-update` as const
export const EXTERNAL_LETTERS_COMPLETE = `${EXTERNAL_LETTERS_LIST}complete` as const
